import type { ReactNode } from "react";

import { Card } from "#/components/ui/card";
import { cn } from "#/lib/utils";

type PromoCardTone = "premium" | "discord";

const promoCardClassName: Record<PromoCardTone, string> = {
  premium:
    "relative w-full overflow-hidden border-premium/60 bg-card shadow-2xl shadow-premium/20 ring-2 ring-premium/70",
  discord:
    "relative w-full overflow-hidden border-discord/60 bg-card shadow-2xl shadow-discord/20 ring-2 ring-discord/70",
};

const promoCardGlowClassName: Record<PromoCardTone, string> = {
  premium: "bg-linear-to-br from-premium/30 via-premium/12 to-card",
  discord: "bg-linear-to-br from-discord/30 via-discord/12 to-card",
};

const promoCardOrbClassName: Record<PromoCardTone, string> = {
  premium: "bg-premium/30",
  discord: "bg-discord/30",
};

export function PromoCardBackground({ tone = "premium" }: { tone?: PromoCardTone }) {
  return (
    <>
      <div
        className={cn("pointer-events-none absolute inset-0", promoCardGlowClassName[tone])}
        aria-hidden
      />
      <div
        className={cn(
          "pointer-events-none absolute -top-20 left-1/2 h-40 w-80 -translate-x-1/2 rounded-full blur-3xl",
          promoCardOrbClassName[tone],
        )}
        aria-hidden
      />
    </>
  );
}

export function PromoCardShell({
  children,
  className,
  tone = "premium",
}: {
  children: ReactNode;
  className?: string;
  tone?: PromoCardTone;
}) {
  return (
    <Card size="default" className={cn(promoCardClassName[tone], className)}>
      <PromoCardBackground tone={tone} />
      {children}
    </Card>
  );
}
